import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, ReactElement } from "react";
import { Alert, Col, Container, Form, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import useAllowedMimeTypeToExtensionsMap from "../../modules/filestore/hooks/useAllowedMimeTypeToExtensionsMap";
import useEUFinanceCurrentUser from "../../modules/filestore/hooks/useEUFinanceCurrentUser";
import CaseAttachmentDropzone from "./components/CaseAttachmentDropzone";

const CLASSNAME = "eu-finance-case-attachment-uploader";

enum QueryParam {
  CASE_ID = "caseId",
  CASE_NUMBER = "caseNumber",
}

const EUFinanceFileUpload: FC = (): ReactElement => {
  const {
    data: allowedMimeTypeToExtensionsMap,
    isLoading: isLoadingAllowedMimeTypeToExtensionsMap,
  } = useAllowedMimeTypeToExtensionsMap();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const caseId = queryParams.get(QueryParam.CASE_ID);
  const caseNumber = queryParams.get(QueryParam.CASE_NUMBER);

  const { data: currentUser, isLoading: isLoadingCurrentUser } =
    useEUFinanceCurrentUser();

  if (isLoadingCurrentUser || isLoadingAllowedMimeTypeToExtensionsMap) {
    return (
      <div
        className={`${CLASSNAME}__loading d-flex justify-content-center align-items-center`}
      >
        <FontAwesomeIcon icon={faSpinner} spin size="10x" />
      </div>
    );
  }

  if (!currentUser?.id) {
    return (
      <div className={`${CLASSNAME}__error`}>
        <Container fluid>
          <Row>
            <Col className="mt-3">
              <Alert variant="danger">
                Oops! We could not locate your account. Try signing in again or
                contact support if the issue continues.
              </Alert>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  if (!caseId || !caseNumber) {
    return (
      <div className={`${CLASSNAME}__error`}>
        <Container fluid>
          <Row>
            <Col className="mt-3">
              <Alert variant="danger">
                Failed to load page. Please try again later or contact support
                if the issue continues.
              </Alert>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div className={CLASSNAME}>
      <Container fluid>
        <Row>
          <Col className="mt-3">
            <Form.Label className="fw-bold">Case Number</Form.Label>
            <Form.Control disabled type="text" defaultValue={caseNumber} />
          </Col>
        </Row>
        <Row>
          <Col className="mt-3">
            <CaseAttachmentDropzone
              caseId={caseId}
              caseNumber={caseNumber}
              label="Case Attachments"
              allowedExtensions={allowedMimeTypeToExtensionsMap}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EUFinanceFileUpload;
